import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import Text from 'components/common/Text/Text'
import Media from 'components/common/Media'
import LocationsMap from '../LocationsMap/LocationsMap'
import { AvailableResultsForm } from '../../../SavedLocationSearchForm'
import Locations from '../Locations/Locations'
import SearchRadius from '../SearchRadius'
import {
  Section,
  ResultsSection,
  MapWrapper,
  SearchWrapper,
  ResultsWrapper
} from '../../../SharedStyledComponents.js'
import { distanceToSearchRadius } from '../../../../helpers'
import { SEARCH_BY_LOCATION } from 'constant'

const DEBOUNCE_INTERVAL = 1000

const StoreLocatorHaveResults = ({
  searchTitle,
  results = [],
  searchMask,
  searchMethod,
  searchCoords,
  selectedSearchResult,
  fetchLocationsByCoords,
  resetSearchRadiusThenSearchByAddr,
  resetSearchRadiusThenSearchByCoords,
  resetSearchAction,
  allowMapInteraction,
  setAllowMapInteractionFlag,
  ...props
}) =>
  <React.Fragment>
    <ResultsSection data-at-store-locator-results>
      <Media.Desktop>
        <Locations results={ results } selectedSearchResult={ selectedSearchResult } { ...props } />
      </Media.Desktop>
      <MapWrapper data-at-map>
        <SearchWrapper>
          <AvailableResultsForm { ...props } />
        </SearchWrapper>
        <LocationsMap
          { ...props }
          selectedItemIndex={ selectedSearchResult }
          results={ results }
          onMapBoundsChange={
            allowMapInteraction && debounce(
              (distance, { lng: longitude, lat: latitude }) =>
                resetSearchRadiusThenSearchByCoords(distanceToSearchRadius(distance), { longitude, latitude }),
              DEBOUNCE_INTERVAL
            )
          }
          onMapIdle={ () => setAllowMapInteractionFlag(true) } />
      </MapWrapper>
      <ResultsWrapper data-at-stores-found>
        <Text size={ 16 }> { searchTitle }</Text>
      </ResultsWrapper>
      <Media.Mobile>
        <Locations results={ results } selectedSearchResult={ selectedSearchResult } { ...props } />
      </Media.Mobile>
    </ResultsSection>
    <Section>
      <SearchRadius
        { ...props }
        selectedItemPositionHandler={ newRadius => searchMethod === SEARCH_BY_LOCATION ?
          resetSearchRadiusThenSearchByAddr(newRadius, searchMask) :
          resetSearchRadiusThenSearchByCoords(newRadius, searchCoords)
        } />
    </Section>
  </React.Fragment>

export default StoreLocatorHaveResults

StoreLocatorHaveResults.propTypes = {
  allowMapInteraction: PropTypes.bool,
  fetchLocationsByCoords: PropTypes.func,
  fetchUsingMapDataAction: PropTypes.func,
  limitedResults: PropTypes.arrayOf(PropTypes.shape()),
  onMapRefBecameAvailable: PropTypes.func,
  resetSearchAction: PropTypes.func,
  resetSearchRadiusThenSearchByAddr: PropTypes.func,
  resetSearchRadiusThenSearchByCoords: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape()),
  searchCoords: PropTypes.shape(),
  searchMask: PropTypes.string,
  searchMethod: PropTypes.string,
  searchTitle: PropTypes.string,
  selectedSearchResult: PropTypes.string,
  setAllowMapInteractionFlag: PropTypes.func
}
